module.exports = __webpack_public_path__ + "img/1F1F1-1F1FA.1b398d79.svg";